var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6483 3C6.87198 3 3 6.95529 3 11.8344C3 16.7135 6.87198 20.6688 11.6483 20.6688C13.7774 20.6688 15.7268 19.8828 17.2337 18.5795L21.2631 22.6956C21.6604 23.1015 22.3047 23.1015 22.702 22.6956C23.0993 22.2897 23.0993 21.6316 22.702 21.2257L18.6229 17.0589C19.6751 15.5957 20.2966 13.7892 20.2966 11.8344C20.2966 6.95529 16.4246 3 11.6483 3ZM11.6483 5.07868C7.99582 5.07868 5.0349 8.10332 5.0349 11.8344C5.0349 15.5655 7.99582 18.5901 11.6483 18.5901C15.3008 18.5901 18.2617 15.5655 18.2617 11.8344C18.2617 8.10332 15.3008 5.07868 11.6483 5.07868Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4a3a4adaf1a8b839dfc251fef74fadd2.svg";
export { ForwardRef as ReactComponent };